import React from "react";
import TextField from "@material-ui/core/TextField";
import { KeyboardDatePicker, MuiPickersUtilsProvider } from "@material-ui/pickers";
import DateFnsUtils from '@date-io/date-fns';
import {defaultInputStyle} from '../../utils'


export default function DatePickerInput({
                                        name, 
                                        onChange,
                                        placeholder,
                                        inputProps,
                                        value='',
                                        error, 
                                        helperText,
                                        maxDate,
                                        minDate,
                                        disabled,
                                        autoOk=true,
                                        style,
                                        FormHelperTextProps }) {

    const handleDateChange = (dateIO, value) => {
        onChange({ target: { name, value}})
    }

    return (
        <MuiPickersUtilsProvider utils={DateFnsUtils}>
            <KeyboardDatePicker
                clearable
                autoOk={autoOk}
                disabled={disabled}
                placeholder={placeholder || 'MM/DD/YYYY'}
                error={error}
                helperText={helperText}
                FormHelperTextProps={FormHelperTextProps}
                inputVariant="outlined"
                margin='dense'
                format="MM/dd/yyyy"
                id={`${name}_input`}
                value={ value || null }
                maxDate={maxDate}
                minDate={minDate}
                onChange={ handleDateChange }
                TextFieldComponent={TextField}
                style={ style || defaultInputStyle}
                inputProps={inputProps}
                KeyboardButtonProps={{"aria-label": "Date Picker"}}
            />
        </MuiPickersUtilsProvider>
    );
}
